import React from "react";
import {
  TextInput,
  SimpleForm,
  required,
  SelectInput,
  EditProps,
} from "react-admin";
import CustomLevelInput from "components/CustomLevelInput";
import { GetParam } from "utils/tools";
import SanitizedGrid from "components/SanitizedGrid";
import { Grid, Typography } from "@material-ui/core";
import { statusList } from "pages/levels/util";
import CustomEditToolbar from "components/CustomEditToolbar";
import EditWrapper from "../../components/EditWrapper";

const LevelGroupsEdit = (props: EditProps) => {
  const param = GetParam();
  const { id } = props;

  const breadcrumb = [
    { title: "Schools", link: `/schools` },
    { title: "Levels", link: `/schools/${param.get("schoolId")}/show/1` },
    {
      title: "Class",
      link: `/levels/${param.get("levelId")}/show`,
      params: `?schoolId=${param.get("schoolId")}`,
    },
    { title: id, link: `` },
  ];

  return (
    <>
      <EditWrapper breadcrumb={breadcrumb} title="Class" {...props}>
        <SimpleForm
          toolbar={
            <CustomEditToolbar
              redirectLink={`/levels/${param.get(
                "levelId"
              )}/show?schoolId=${param.get("schoolId")}`}
            />
          }
        >
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">Level</Typography>
            </Grid>
            <Grid item xs={4}>
              <CustomLevelInput />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Details</Typography>
            </Grid>
            <Grid item xs={4}>
              <TextInput source="name" validate={required()} />
            </Grid>
            <Grid item xs={4}>
              <SelectInput
                source="status"
                choices={statusList}
                validate={required()}
              />
            </Grid>
          </SanitizedGrid>
        </SimpleForm>
      </EditWrapper>
    </>
  );
};

export default LevelGroupsEdit;
